import { newDataAPI } from "../apiConsumer";

export const upload = async (file) => {
  return await newDataAPI.post(`/upload`, file);
};

